// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"1059cfcd","689":"f4cc15fb"}[chunkId] + ".chunk.js";
};